// extracted by mini-css-extract-plugin
export default {"button_scroll_top":"ScrollToTopButton_button_scroll_top__811JC","show":"ScrollToTopButton_show__PBYwx","bounce":"ScrollToTopButton_bounce__dHnHs"};